export default "__VITE_ASSET__CaJ12fw2__"